var Loading = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-loadingbox",
      "class": [_vm.mask ? 'k-loadingbox-mask' : '']
    }, [_c('div', {
      staticClass: "k-loadingbox-loader"
    }, [_c('svg', {
      staticClass: "k-loadingbox-circular",
      attrs: {
        "viewBox": "25 25 50 50"
      }
    }, [_c('circle', {
      staticClass: "k-loadingbox-path",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "20",
        "fill": "none",
        "stroke-miterlimit": "10"
      }
    })])])]);
  },
  staticRenderFns: [],
  name: 'KLoading',
  props: {
    // 是否显示半透明遮罩层
    mask: {
      type: Boolean,
      "default": false
    }
  }
};

Loading.install = function (Vue) {
  Vue.component(Loading.name, Loading);
};

export { Loading as default };
